import axiosInstance from 'ns_libs/nsAxios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { IProFormaSocketRoomData } from 'views/ProFormaTable/types';

interface IProjectActualsProps {
    dealId: number;
    proFormaId: number;
    organizationId: string;
    shouldGetActuals: boolean;
    forecastMetric?: string;
    scenarioId?: string | null;
}

const getProFormaRoom = async ({
    dealId, proFormaId, shouldGetActuals, organizationId, forecastMetric, scenarioId,
}: IProjectActualsProps): Promise<IProFormaSocketRoomData> => {
    let queryStrings = `organizationId=${organizationId}&shouldGetActuals=${shouldGetActuals}`;

    if (forecastMetric) {
        queryStrings = `${queryStrings}&forecastMetric=${forecastMetric}`;
    }
    if (scenarioId) {
        queryStrings = `${queryStrings}&scenarioId=${scenarioId}`;
    }
    const response = await axiosInstance.get(`${API_ENDPOINTS.PRO_FORMA_ROOM(dealId, proFormaId)}?${queryStrings}`);
    return response.data;
};

const useGetProFormaRoom = (
    dealId: number, proFormaId: number, organizationId: string, shouldGetActuals: boolean,
    forecastMetric: string, scenarioId: string | null,
    options: Omit<UseQueryOptions<IProFormaSocketRoomData, Error, IProFormaSocketRoomData>, 'queryKey' | 'queryFn'> = { enabled: true },
) => useQuery<IProFormaSocketRoomData>({
    queryKey: ['ProFormaRoom', dealId, proFormaId, organizationId, forecastMetric, scenarioId],
    queryFn: () => getProFormaRoom({
        dealId, proFormaId, organizationId, shouldGetActuals, forecastMetric, scenarioId,
    }),
    ...options,
});

export default useGetProFormaRoom;
